const STORAGE_KEY = 'quiklearn.webgl.access-token';
const LAUNCH_STORAGE_KEY = 'quiklearn.webgl.launch-token';
const FRAGMENT_KEY = 'access_token';
const LAUNCH_FRAGMENT_KEY = 'launch_token';
const MAX_TOKEN_LENGTH = 8192;

const validToken = value =>
  typeof value === 'string' &&
  value.length > 0 &&
  value.length <= MAX_TOKEN_LENGTH &&
  !/[\s\u0000-\u001f\u007f]/.test(value);

export const captureWebAccessToken = () => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return null;
  const fragment = new URLSearchParams(String(window.location.hash || '').replace(/^#/, ''));
  const supplied = fragment.get(FRAGMENT_KEY);
  const launch = fragment.get(LAUNCH_FRAGMENT_KEY);
  if (supplied !== null) {
    validToken(supplied)
      ? sessionStorage.setItem(STORAGE_KEY, supplied)
      : sessionStorage.removeItem(STORAGE_KEY);
  }
  if (launch !== null) {
    validToken(launch)
      ? sessionStorage.setItem(LAUNCH_STORAGE_KEY, launch)
      : sessionStorage.removeItem(LAUNCH_STORAGE_KEY);
  }
  fragment.delete(FRAGMENT_KEY);
  fragment.delete(LAUNCH_FRAGMENT_KEY);
  const nextUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, '', nextUrl);
  return sessionStorage.getItem(STORAGE_KEY);
};

export const getWebAccessToken = () => {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(STORAGE_KEY);
};

export const getWebLaunchToken = () => {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(LAUNCH_STORAGE_KEY);
};

/**
 * True when `next` differs from `current` only after the '#'. Setting such an address only changes the hash: the page
 * does not load the new launch (owner 13 Oct: "landing to unit 3 via next unit portal ... unit never loaded unless i
 * refreshed" - the next-unit launch carries the same query as the page it leaves, and its token sits in the hash).
 */
export const onlyHashDiffers = (next, current) => {
  try {
    const to = new URL(next, current);
    const from = new URL(current);
    return to.origin === from.origin && to.pathname === from.pathname && to.search === from.search;
  } catch (_) {
    return false;
  }
};

/** Opens a launch address (buildWebLaunchLocation) in this tab, loading it even when only its hash is new. */
export const goToWebLaunch = url => {
  const here = window.location.href;
  window.location.href = url;
  if (onlyHashDiffers(url, here)) window.location.reload();
};

export const buildWebLaunchLocation = (baseUrl, launchToken, queryValues = {}) => {
  if (!validToken(launchToken)) throw new Error('A valid launch token is required.');
  const origin = typeof window !== 'undefined' && window.location.origin
    ? window.location.origin
    : 'https://app.quiklearn.ai';
  const url = new URL(baseUrl, origin);
  Object.entries(queryValues).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });
  url.hash = new URLSearchParams({launch_token: launchToken}).toString();
  return url.toString();
};
